import { Injectable, EventEmitter } from '@angular/core';
import { FormGroup, FormArray, FormControl, Validators } from '@angular/forms';

@Injectable()
export class RegularPaymentFormService {

    regularPaymentForm: FormGroup;
    documentsForm: FormArray;
    paymentMethodForm: FormGroup;
    paymentMethodControl: FormControl;
    networkingControl: FormControl;
    networkingDetailControl: FormControl;

    totalToPayControl: FormControl;
    // totalToPayChange = new EventEmitter<number>();

    constructor() {
        this.resetForm();
    }

    resetForm(): void {
        this.regularPaymentForm = new FormGroup({});

        this.totalToPayControl = new FormControl(0, Validators.required);
        this.regularPaymentForm.addControl('totalToPay', this.totalToPayControl);

        this.documentsForm = new FormArray([], Validators.minLength(1));
        this.regularPaymentForm.addControl('documents', this.documentsForm);

        this.paymentMethodForm = new FormGroup({});

        this.paymentMethodControl = new FormControl(null, Validators.required);
        this.paymentMethodForm.addControl('paymentMethod', this.paymentMethodControl);

        this.networkingControl = new FormControl(null, Validators.required);
        this.paymentMethodForm.addControl('networking', this.networkingControl);

        this.networkingDetailControl = new FormControl(null);
        this.paymentMethodForm.addControl('networkingDetail', this.networkingDetailControl);

        this.regularPaymentForm.addControl('paymentMethods', this.paymentMethodForm);
    }

}
